import { Avatar, Box, Card, CardContent, Typography, styled, Tooltip } from "@mui/material";
import QueueIcon from '@mui/icons-material/Queue';
import GradientIcon from '@mui/icons-material/Gradient';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { FC } from "react";
import { Link as RouterLink } from 'react-router-dom'

export const TileEntryLink = styled(RouterLink)(({ theme }) => ({
  textDecorationLine: 'none',
  '&.disabled': {
    cursor: 'default',
    '& .MuiAvatar-root': {
      bgcolor: theme.palette.action.disabledBackground,
      '& .MuiSvgIcon-root': {
        color: theme.palette.action.disabled
      },
    },
    '& h6': {
      color: theme.palette.text.disabled
    }
  },
}))

export const TileContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& .MuiAvatar-root': {
    width: 112, 
    height: 112, 
    backgroundColor: 'rgba(86, 100, 210, 0.08)',
    marginTop: theme.spacing(2),
    '& .MuiSvgIcon-root': {
      fontSize: 45,
      color: theme.palette.primary.main,
    },
  },
  '& > h6': {
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
}))

export const CreateBackupEntryTile: FC = () => {
  return (
    <TileEntryLink 
      to={{
        pathname: "/backups-n-validations/dashboard",
        state: { openCreate: true }
      }}
    >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <QueueIcon />
            </Avatar>
            <Typography variant="h6">
              Create Backup
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const CreateEncryptionEntryTile: FC = () => {
  return (
    <TileEntryLink 
      to={{
        pathname: "/encryption/list",
        state: { openCreate: true },
      }} 
    >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <GradientIcon />
            </Avatar>
            <Typography variant="h6">
              Encrypt Database
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const CreateDeploymentEntryTile: FC = () => {
  return (
    <TileEntryLink 
      to={{
        pathname: "/deployments/list",
        state: { openCreate: true },
      }} 
    >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <UnarchiveIcon />
            </Avatar>
            <Typography variant="h6">
              Deploy Database
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const CreateAuditEntryTile: FC = () => {
  return (
    <TileEntryLink to="" sx={{ cursor: 'default' }} >
      <Tooltip title="This feature will be available in next release.">
        <Card>
          <CardContent>
            <TileContent
              sx={{
                '& .MuiAvatar-root': {
                  bgcolor: 'action.disabledBackground',
                  '& .MuiSvgIcon-root': {
                    color: 'action.disabled'
                  },
                },
                '& > h6': {
                  color: 'text.disabled'
                }
              }}
            >
              <Avatar>
                <AssignmentIcon />
              </Avatar>
              <Typography variant="h6">
                Create Audit Report
              </Typography>
            </TileContent>
          </CardContent>
        </Card>
      </Tooltip>
    </TileEntryLink>
  )
}

export const CreateSecureFileManagementTile: FC<{disabled?:boolean}> = ({disabled}) => {
  const content = 
    <Card>
      <CardContent>
        <TileContent>
          <Avatar>
            <AssignmentIcon />
          </Avatar>
          <Typography variant="h6">
            Manage SecureFiles
          </Typography>
        </TileContent>
      </CardContent>
    </Card>

  return (
    <TileEntryLink to={disabled ? "" : "/secure-files/dashboard"} className={disabled ? 'disabled' : undefined}>
      {disabled
      ? <Tooltip title="This feature is not enabled">
          {content}
        </Tooltip>
      : content
      }
    </TileEntryLink>
  )
}

